import type {State} from 'src/reducers';
/*
 * Base Selectors
 */

export const selectFullscreen = (state: State): boolean =>
  state.appConfig.fullscreen;

export const selectSideNavExpanded = (state: State): boolean =>
  state.appConfig.isSideNavExpanded;
